export type Bonus = {
  number: string
  title: string
  accent: string
  dot: string
  hook: string
  body: string
  tags: string
}

export const BONUSES: Bonus[] = [
  {
    number: '01',
    title: 'SPANISH PRONUNCIATION & CORRECTION TOOLKIT™',
    accent: 'border-l-brand',
    dot: 'bg-brand',
    hook: 'Work on pronunciation, intelligibility and recurring errors with a practical system designed for real Spanish lessons.',
    body: 'Identify priority pronunciation targets, use structured correction techniques and help students transfer clearer production into real communication.',
    tags: 'Pronunciation · Correction · Intelligibility · Practice · Feedback',
  },
  {
    number: '02',
    title: 'SPANISH HOMEWORK & INDEPENDENT PRACTICE SYSTEM™',
    accent: 'border-l-violet',
    dot: 'bg-violet',
    hook: 'Stop creating homework from scratch after every lesson.',
    body: "Select practical between-lesson tasks for vocabulary, grammar, speaking, writing, review and independent practice according to each student's needs.",
    tags: 'Homework · Practice · Review · Consolidation · Independent Learning',
  },
  {
    number: '03',
    title: 'REAL-WORLD SPANISH SCENARIO PACK™',
    accent: 'border-l-mustard',
    dot: 'bg-mustard',
    hook: 'Move students from knowing Spanish to actually using it in realistic situations.',
    body: 'Access structured scenarios with communication goals, useful language, roles, challenges and follow-up tasks for practical speaking lessons.',
    tags: 'Scenarios · Role-Plays · Communication · Real Life · Fluency',
  },
  {
    number: '04',
    title: 'SPANISH READING & COMPREHENSION TOOLKIT™',
    accent: 'border-l-coral',
    dot: 'bg-coral',
    hook: 'Access structured Spanish reading material without constantly searching for suitable texts.',
    body: 'Use level-appropriate readings with comprehension tasks, vocabulary work and speaking or writing extensions.',
    tags: 'Reading · Comprehension · Vocabulary · Questions · Production',
  },
  {
    number: '05',
    title: 'STUDENT RETENTION & LESSON CONTINUITY SYSTEM™',
    accent: 'border-l-sage',
    dot: 'bg-sage',
    hook: 'Connect one lesson to the next and maintain a clearer direction for every student.',
    body: 'Track priority goals, recurring difficulties, previous targets and next steps with simple tools designed to create greater teaching continuity.',
    tags: 'Continuity · Goals · Review · Progress · Next Lessons',
  },
]
